import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useAnnualRevenueLogic } from './hooks/useAnnualRevenueLogic';
import { AnnualRevenueForm } from './AnnualRevenueForm';

export const EddAnnualRevenue = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useAnnualRevenueLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.annualRevenue.title')}
        text={t('organic.annualRevenue.subtitle')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'>
        <AnnualRevenueForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
